// extracted by mini-css-extract-plugin
export default {"container":"Uf","blur":"Vf","spinner":"Wf","spin":"Xf"};